import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import HeaderShell from './HeaderShell';

const SuperAdminHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const hasPathAfterSuperadmin = location.pathname !== '/lkart/superadmin/';

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      localStorage.removeItem('superadmintoken');
      toast.success('Logged out successfully');
      navigate('/lkart/superadmin/');
    }
  };

  return (
    <HeaderShell
      showHomeButton={hasPathAfterSuperadmin}
      onHomeClick={() => navigate('/lkart/superadmin/view')}
      showBellButton={false}
      showLogoutButton={hasPathAfterSuperadmin}
      onLogoutClick={handleLogout}
    />
  );
};

export default SuperAdminHeader;